import {IconTent} from "./svg-icons/IconTent.tsx";
import {IconBed} from "./svg-icons/IconBed.tsx";
import {Tooltip} from "./ToolTip.tsx";
import "../styles/components/AccommodationIcon.css"

interface AccommodationIconProps {
    icon?: string
    colorClass?: string
    toolTipText?: string
}

export function AccommodationIcon({
                                      icon = 'bed',
                                      colorClass,
                                      toolTipText
                                  } : AccommodationIconProps) {

    {/*
        Possible Color Classes:
        region-europe
        region-asia
        region-africa
        region-america
    */}

    const getAccommodationIcon = (icon: string) => {

        if (icon === 'tent' || icon === 'Zelt') return {
            svg : <IconTent />,
            text : 'Die Übernachtungen finden in Zelten statt. Nähere Details finden Sie im Tagesablauf oder in den Leistungen der Reise.'
        }

        if (icon === 'bed' || icon === 'Hotel' || icon === 'Jurte' || icon === 'Boot') return {
            svg :  <IconBed />,
            text: 'Die Übernachtungen finden in festen Unterkünften statt. Nähere Details finden Sie im Tagesablauf oder in den Leistungen der Reise.'
        }

        return {
            svg: <IconBed />,
            text: 'Die Übernachtungen finden in festen Unterkünften statt. Nähere Details finden Sie im Tagesablauf oder in den Leistungen der Reise.'
        }
    }

    if((!toolTipText || toolTipText === '')) {
        return (
            <span className={`tent-bed-icon ${colorClass}`}>
                {getAccommodationIcon(icon)?.svg}
            </span>
        );
    }

    return (
        <span className={`tent-bed-icon ${colorClass}`}>
            <Tooltip
                content={(toolTipText && toolTipText !== '') ? toolTipText : getAccommodationIcon(icon)?.text}
            >
                {getAccommodationIcon(icon)?.svg}
            </Tooltip>
        </span>
    )
}
